function create_cart(){
   jQuery.getJSON('/cart.js', function(cart) {
     const savedBy = cart.items.find(i => i.vendor === "SavedBy");
     if(savedBy) cart.item_count--;
     
     $('.cart-count-bubble').text(cart.item_count);
      if(cart.item_count > 0){
         $('.cart-count-bubble').show();        
      }
     else{
       $('.cart-count-bubble').hide();
     }  
     $('.cart_drawer').load('/ .inner_cart_drawer');
   });
}

$(document).on('click','.btn_add_to_cart',function(){
   $('body').trigger('added.ajaxProduct');
  var temp_form_id = $(this).attr('data-id'),
      temp_form_val = $(this).parents('.btn_qty').find('.quantity__input').val() || 1;
 addtocart_product(temp_form_id, temp_form_val);
 
  //return false;
});

$(document).on('click','.cart_link', function(){
  //open_close_drawer();
 // $('body').trigger('added.ajaxProduct');
  return false;
});


function addtocart_product(variantId, quantity){
  
  var quantity = quantity;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variantId,
    dataType: 'json',
    success: function(line_item) { 
      
      $('body').trigger('added.ajaxProduct');
    },
    error: function(XMLHttpRequest, textStatus) {
      console.log('error');
      }
    };
  jQuery.ajax(params);
};



// function addtocart_product(variantId, quantity){  
//   var data = {
//       "id": variantId,
//       "quantity": quantity,
//       "properties": {
//         "shipping_interval_frequency": frequency,
//         "shipping_interval_unit_type": unit_type
//       }
//     }
//   console.log(data)
//   var params = {
//     type: 'POST',
//     url: '/cart/add.js',
//     data: data,
//     dataType: 'json',
//     success: function(line_item) {       
//       $('body').trigger('added.ajaxProduct');
//     },
//     error: function(XMLHttpRequest, textStatus) {
//       console.log('error');
//       }
//     };
//   jQuery.ajax(params);
// };

function open_close_drawer(){
   $('body').addClass('open_cart');
   if( $(".overlay_widget").length < 1){
     $('body').append('<div class="overlay_widget">&nbsp;</div>');
   }
   $(document).on('click', '.overlay_widget', function(){
     $('body').removeClass('open_cart');
     $('.overlay_widget').remove();
   });
   $(document).on('click', '.close_drawer', function(){
     $('body').removeClass('open_cart');
     $('.overlay_widget').remove();
   });
};

function update_qty(line, qty){
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: "quantity="+qty+"&line=" + line,
    dataType: 'json',
    success: function(cart) {
      create_cart();
      if(qty > 0 ){
        if((cart.items[line-1].quantity) != qty){
          alert ("You have only " + cart.items[line-1].quantity + " quantity available in stock. ");
        }
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.api.onError(XMLHttpRequest, textStatus);
    }
  }; 
  $.ajax(params);
}


$(document).ready(function(){
  create_cart();
});

$(document).on('click', '.QuantityBox .plus', function() {            
  var $qty = $(this).parents('.QuantityBox').find(".cart_qty_input"),
    currentVal = parseInt($qty.val(), 10),
    line = $(this).parents('.QuantityBox').attr('data-line');
  if (1 <= currentVal) {
    $(this).parents('.QuantityBox').find('.minus_box').removeClass('disabled');
  }
  if (!isNaN(currentVal)) { 
    $qty.val(currentVal + 1);
    var qty = $qty.val();
    update_qty(line, qty)
  } 
});
$(document).on('click', '.QuantityBox .minus', function() { 
  var $qty = $(this).parents('.QuantityBox').find(".cart_qty_input"),
   currentVal = parseInt($qty.val(), 10),
    line = $(this).parents('.QuantityBox').attr('data-line');
  if (currentVal <= 1) {
    $(this).parents('.QuantityBox').find('.minus_box').addClass('disabled');
  }
  if (!isNaN(currentVal) && currentVal > 0) {
    $qty.val(currentVal - 1);
    var qty = $qty.val();
    update_qty(line, qty)
  }
});


